if (!customElements.get('carousel-with-custom-nav')) {
  customElements.define(
    'carousel-with-custom-nav',
    class CarouselWithCustomNav extends HTMLElement {
      constructor() {
        super();
        this.sliderInstance = null;
      }

      connectedCallback() {
        if (!window.FoxTheme || !window.FoxTheme.Carousel) return;

        this.swiperEl = this.querySelector('.swiper');
        this.wrapper = this.querySelector('.swiper-wrapper');

        this.prevEl = this.querySelector('.swiper-button-prev');
        this.nextEl = this.querySelector('.swiper-button-next');
        this.pagination = this.querySelector('.swiper-pagination');

        this.customNavButtons = [
          ...this.querySelectorAll('.custom-navigation .custom-swipper-nav')
        ];

        this.iconCards = [
          ...this.querySelectorAll('.icon-with-info .icon-card')
        ];

        if (!this.swiperEl || !this.wrapper) return;

        this.initSlider();
        this.bindCustomNavigation();
        this.setActiveIcon(0);
      }

      initSlider() {
        if (this.sliderInstance) return;

        const options = {
          slidesPerView: 1,
          watchOverflow: true,
          threshold: 2,

          navigation:
            this.prevEl && this.nextEl
              ? { prevEl: this.prevEl, nextEl: this.nextEl }
              : false,

          pagination:
            this.pagination
              ? { el: this.pagination, clickable: true }
              : false,

          on: {
            slideChange: () => {
              const index = this.sliderInstance.slider.activeIndex;
              this.setActiveIcon(index);
              this.setActiveCustomNav(index);
            }
          }
        };

        this.sliderInstance = new window.FoxTheme.Carousel(
          this.swiperEl,
          options
        );

        this.sliderInstance.init();
      }

      bindCustomNavigation() {
        if (!this.customNavButtons.length) return;

        this.customNavButtons.forEach((btn, index) => {
          btn.addEventListener('click', () => {
            if (!this.sliderInstance) return;
            this.sliderInstance.slider.slideTo(index);
          });
        });
      }

      setActiveIcon(index) {
        if (!this.iconCards.length) return;

        this.iconCards.forEach((card, i) => {
          card.classList.toggle('active', i === index);
        });
      }

      setActiveCustomNav(index) {
        if (!this.customNavButtons.length) return;

        this.customNavButtons.forEach((btn, i) => {
          btn.classList.toggle('active', i === index);
        });
      }

      disconnectedCallback() {
        if (this.sliderInstance) {
          this.sliderInstance.slider.destroy();
          this.sliderInstance = null;
        }
      }
    }
  );
}
